import styled from 'styled-components';

const defaultFont =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

const helveticaNeueFont = 'HelveticaNeue';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  align-content: center;
  height: ${props => props.height || `80vh`};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 100px 0 0;
`;

export const Heading = styled.h1`
  font-size: 45px;
  font-weight: bold;
  margin: 0;
  padding: 0 0 20px 0;
  font-family: ${props => props.fontFamily || defaultFont};

  @media only screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    font-size: 25px;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0 0 0;

  @media only screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    transform: scale(0.8);
  }
`;

export const SuggestionText = styled.span`
  font-family: ${() => `${helveticaNeueFont}, ${defaultFont}`};
  font-size: 24px;
  padding: 0 0 32px 0;

  @media only screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    font-size: 20px;
  }
`;

export const ActionText = styled.span`
  font-size: 18px;

  @media only screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    font-size: 16px;
  }
`;
